import { UserApi, getApiConfigNext, type UserPlayer, type UserTeams } from '@y-sports/api-client';

export interface UserOfficialOption {
  id?: string;
  personId?: string;
  firstName: string;
  lastName: string;
  yearOfBirth: number;
  phoneNumber: string;
}

export interface UserPeopleInventory {
  players: UserPlayer[];
  officials: UserOfficialOption[];
}

export const UserPeopleDataService = {
  getUserPeopleInventory: async (email: string): Promise<UserPeopleInventory> => {
    const apiConfig = await getApiConfigNext();
    const userApi = new UserApi(apiConfig);
    const [userPlayers, userTeams] = await Promise.all([
      userApi.getUserPlayers({ email }),
      userApi.getUserTeams({ email }),
    ]);

    const officialsMap = new Map<string, UserOfficialOption>();
    (userTeams || []).forEach((group: UserTeams) => {
      group.teams?.forEach((team) => {
        team.officials?.forEach((official) => {
          const birthYear = Number(official.birthDate);
          if (!official.firstName || !official.lastName || !birthYear || Number.isNaN(birthYear)) {
            return;
          }

          const key = official.id || `${official.firstName}|${official.lastName}|${birthYear}`;
          if (!officialsMap.has(key)) {
            officialsMap.set(key, {
              id: official.id,
              personId: official.id,
              firstName: official.firstName,
              lastName: official.lastName,
              yearOfBirth: birthYear,
              phoneNumber: official.phoneNumber || '',
            });
          }
        });
      });
    });

    return {
      players: userPlayers as UserPlayer[],
      officials: Array.from(officialsMap.values()),
    };
  },
};